<template>
  <div class="productClassInfo">
    <div class="left">
      <div class="img">
        <img width="100%" height="100%" :src="ip + '/image_product/产品详情/' + classData.img" alt="" srcset="" />
      </div>
    </div>
    <div class="right">
      <div class="title">{{ name }}</div>
      <div class="line"></div>

      <div class="box">
        <!-- <div class="text" v-if="classData.class_text_type==1" v-for="(item, index) in text" :key="index">
                    <div class="text_title">{{item.name}}: </div>
                    <div class="text_content">{{item.txt}}</div>                
                </div> -->
        <div class="text" v-html="text"></div>
        <div class="bottom">
          <div class="imgList">
            <div class="img_box" v-for="(item, index) in productImgList" :key="index" @click="toProductInfo(index)">
              <img :src="ip + '/image_product/产品详情/' + item.img" width="100%" height="100%" alt="" srcset="" />
            </div>
          </div>
          <div class="btn_box">
            <div class="btn" v-show="
              (this.classData.classId == 4 &&
                this.classData.productId != 15) ||
              classData.productId == 1 ||
              classData.productId == 2 ||
              classData.productId == 3 ||
              classData.productId == 5
            " @click="download()">
              {{ $t("下载") }}
              <div class="img" style="transform: translate(-50%,-50%);right: 0;top: 50%;"></div>
            </div>
            <div class="btn" @click="toEmail()">
              <div class="img" style="transform: translate(50%,-50%);left: 0;top: 50%;"></div>
              E-mail
            </div>

            <div class="btn" @click="mores()">
              {{ $t("详细了解") }}
              <div class="img" style="transform: translate(-50%,-50%);right: 0;top: 50%;"></div>
            </div>
          </div>
          <div class="download_file_btn_box" v-show="
            (this.classData.classId == 4 &&
              this.classData.productId != 15) ||
            classData.productId == 1 ||
            classData.productId == 2 ||
            classData.productId == 3 ||
            classData.productId == 5
          " >
            <div class="download_file_btn download_cursor">declaration of conformity</div>
            <div class="download_file_btn ucka">
              <div class="download_cursor mr-12" @click.stop="download_UKCA()">
                declaration of conformity（UKCA）
              </div>
              <div class="download_cursor" @click.stop="download_new_ukca()">{{ download_new_ukca_name() }}</div>
            </div>
            <div class="download_file_btn download_cursor" @click.stop="dowload_FFP3()">
              FFP3 face mask DOC
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["classData"],
  data() {
    return {
      productImgList: [],
      baseUrl: process.env.BASE_URL,
    }
  },
  created() {
    this.classId = this.classData.classId
    this.productId = this.classData.productId
    let _this = this
    this.$axios({
      method: "post",
      url: this.ip + "/getProductImg",
      data: this.qs.stringify({
        productId: this.productId,
      }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
      .then((response) => {
        //这里使用了ES6的语法
        _this.productImgList = response.data.data
        // console.log(_this.productImgList)
      })
      .catch((error) => {
        console.log(error) //请求失败返回的数据
      })
  },
  methods: {
    toProductInfo(i) {
      this.$router.push({
        path: "/productClass_info", //这个path就是你在router/index.js里边配置的路径
        query: {
          productId: this.productList[i].productId,
          classId: this.productList[i].classId,
        },
      })
    },
    mores() {
      this.$router.push(
        `/productClass_info?productId=${this.classData.productId}&classId=${this.classData.classId}`
      )
    },
    toEmail() {
      this.$router.push("/contact?Type=Email")
    },
    download() {
      // 12 Draft EU Declaration of Conformity
      if (this.classData.productId == 1) {
        window.location.href = "http://www.yuchengprotect.com/PDF/Y2070.pdf"
      } else if (this.classData.productId == 2) {
        window.location.href = "http://www.yuchengprotect.com/PDF/Y2050.pdf"
      } else if (this.classData.productId == 3) {
        window.location.href = "http://www.yuchengprotect.com/PDF/Y2090.pdf"
      } else if (this.classData.productId == 5) {
        window.location.href = "http://www.yuchengprotect.com/PDF/Y2030.pdf"
      } else {
        window.location.href =
          "http://www.yuchengprotect.com/PDF/12%20Draft%20EU%20Declaration%20of%20Conformity.pdf"
      }
    },
    download_new_ukca() {
      if (this.classData.productId == 1) {
        window.location.href = "http://www.yuchengprotect.com/PDF/YC2070_UKCA.pdf"
      } else if (this.classData.productId == 2) {
        window.location.href = "http://www.yuchengprotect.com/PDF/YC2050_UKCA.pdf"
      } else if (this.classData.productId == 3) {
        window.location.href = "http://www.yuchengprotect.com/PDF/YC2090_UKCA.pdf"
      } else if (this.classData.productId == 5) {
        window.location.href = "http://www.yuchengprotect.com/PDF/YC2030_UKCA.pdf"
      } else {
        window.location.href =
          "http://www.yuchengprotect.com/PDF/12%20Draft%20EU%20Declaration%20of%20Conformity.pdf"
      }
    },
    download_new_ukca_name() {
if (this.classData.productId == 1) {
        return `YC2070_UCKA.pdf`
      } else if (this.classData.productId == 2) {
        return `YC2050_UCKA.pdf`
      } else if (this.classData.productId == 3) {
        return `YC2090_UCKA.pdf`
      } else if (this.classData.productId == 5) {
        return `YC2030UCKA.pdf`
      }
    },
    download_UKCA() {
      window.location.href = "http://www.yuchengprotect.com/PDF/UK.pdf"
    },
    dowload_FFP3() {
      window.location.href = "http://www.yuchengprotect.com/PDF/FFP3.pdf"
    },
  },
  computed: {
    text() {
      return this.$i18n.locale == "zh"
        ? this.classData.lead_zh
        : this.classData.lead_en
    },
    name() {
      return this.$i18n.locale == "zh"
        ? this.classData.name_zh
        : this.classData.name_en
    },
  },
}
</script>
<style lang="less" scoped>
@width: 55vw;
@height: @width / 3.14;
@import url("../assets/font.css");

.download_file_btn_box {
  margin-top: 8px;
}

.mr-12 {
  margin-right: 48px;
}
.ucka {
  display: flex;
  align-items: center;
}

.download_file_btn {
  color: #ccc;
  font-size: 0.8vw;
}

.download_cursor {
  cursor: pointer;
}

.productClassInfo {
  width: @width;
  min-height: @height;
  // background-color: red;
  display: flex;
  margin-bottom: 25px;
  justify-content: space-between;

  .left {
    width: @height*1.06;
    // height: @height;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;

    .img {
      width: 92%;
      margin-top: 10px;
      // height: 92%;
      // background-color: aquamarine;
    }
  }

  .btn_box {
    display: flex;

    .btn {
      margin-right: 30px;
      font-family: "YHBD";
      color: #ffffff;
      width: 10vw;
      text-align: center;
      font-size: 0.8vw;
      height: 1.8vw;
      background-image: linear-gradient(45deg, #009d40, #007ca9);
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      cursor: pointer;

      .img {
        position: absolute;
        width: 1.8vw;
        height: 1.1vw;
        // margin: 0px 10px;
        // background-color: red;
      }

      position: relative;

      .detail {
        position: absolute;
        bottom: 0;
        left: 0%;
        transform: translate(0%, 120%);
        color: #ccc;
        font-size: 0.8vw;
        white-space: nowrap;
      }

      .detail_UKCA {
        position: absolute;
        bottom: -50%;
        left: 0%;
        transform: translate(0, 120%);
        color: #ccc;
        font-size: 0.8vw;
        white-space: nowrap;
      }

      .detail_FFP3 {
        position: absolute;
        bottom: -50%;
        left: 0%;
        transform: translate(0, 200%);
        color: #ccc;
        font-size: 0.8vw;
        white-space: nowrap;
      }
    }
  }

  .box {
    // background-color: red;
    min-height: @height - 4vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .bottom {
    margin-bottom: 10px;
    width: calc((@width - @height*1.06) - 30px);
    height: fit-content;
    margin-top: 10px;

    // position: absolute;
    // left: 0;
    // bottom: 0;
    .imgList {
      width: 100%;
      height: fit-content;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .img_box {
        width: 10%;
        height: 3.5vw;
        margin-left: 1%;
        margin-bottom: 0.5vw;
        border: 1px solid #007da7;
      }
    }
  }

  .right {
    width: calc((@width - @height*1.06) - 30px);
    min-height: @height;
    background-color: #ffffff;
    position: relative;

    .title {
      // font-size: 20px;
      letter-spacing: 3px;
      color: #444444;
      font-family: "YHBD";
      font-weight: bold;
      line-height: 30px;
      font-size: 1.3vw;
      line-height: 3vw;
    }

    .line {
      background-color: #444444;
      height: 2px;
      width: 100%;
      margin-bottom: 10px;
      transform: scaleY(0.3);
    }

    .text {
      color: #5e5e5e;
      width: 100%;
      font-weight: bold;
      height: fit-content;
      display: flex;
      line-height: 160%;
      // letter-spacing: 3px;
      // line-height: 1.6vw;
      // background-color: red;
      // font-size: 0.6vw;
      font-size: 12px;

      .text_title {
        width: fit-content;
        white-space: nowrap;
        // font-family: "YH";
        // font-family: 'pf';
      }

      .text_content {
        // font-family: "YH";
        font-family: "pf";
      }
    }
  }
}
</style>
